import api from "./axiosConfig";
import { TRANSLATION_ENDPOINT, TRANSLATION_GLOBAL_ENDPOINT } from "./apiEndpoints";
import languages from "../store/lang";
import { logError } from './errorLogService';

export const fetchTranslation = async (isoCountry = "gl", env = "prod", lang = 'eng') => {
  try {
    if (isoCountry == 'gl') {
      const response = await api.get(TRANSLATION_GLOBAL_ENDPOINT(isoCountry, env, lang));
      return response.data;
    } else {
      const response = await api.get(TRANSLATION_ENDPOINT(isoCountry, env));
      return response.data;
    }


  } catch (error) {
    console.error("Error fetching translation data", error);

    await logError('translation_data_fetch', error, {
      endpoint: isoCountry === 'gl' ? TRANSLATION_GLOBAL_ENDPOINT(isoCountry, env, lang) : TRANSLATION_ENDPOINT(isoCountry, env),
      isoCountry,
      env,
      lang,
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    return languages["en"];
    //console.error("Error fetching translation data", error);
    //throw error;
  }
};
